import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useOfflineManagerFobMutation } from '../../api';

function OfflineManagerDoWork() {
  const navigate = useNavigate();
  const {
    state: { fob, pin },
  } = useLocation();

  const [triggerManagerFob] = useOfflineManagerFobMutation();
  const [errorCode, setErrorCode] = useState<number | null>(null);

  useEffect(() => {
    triggerManagerFob({ fob, pin })
      .unwrap()
      .then(() => {
        console.warn('Manager fob granted successfully');
        navigate('/');
      })
      .catch((error) => {
        console.error('Error granting manager fob', error);
        setErrorCode(error.status);
      });
  }, [triggerManagerFob, navigate, fob, pin]);

  return (
    <div className="pos-modal-portal">
      <div
        className="pos-modal-overlay"
        onClick={(e) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if ((e.target as any).className === 'pos-modal-overlay') navigate('/');
        }}
      >
        <div className="pos-modal pos-modal_role_sign-in">
          <div className="pos-modal__content">
            <div className="pos-sign-in js-sign-in">
              <div className="pos-sign-in__header">
                <h2 className="pos-sign-in__title">Manager Fob</h2>
                <p className="pos-sign-in__subtitle">Attempting to grant manager fob. please wait</p>
                <p className="pos-sign-in__subtitle">{fob}</p>
              </div>
              <div className="pos-sign-in__info">
                <p className="pos-sign-in__label">
                  {errorCode === 412 && <span style={{ color: 'red' }}>Error: Invalid PIN code</span>}
                  {errorCode === 406 && <span style={{ color: 'red' }}>Error: Invalid PIN Code</span>}
                  {errorCode === 422 && (
                    <span style={{ color: 'red' }}>Error: Please ensure you have fobbed on once on the Offline till</span>
                  )}
                  {errorCode === 500 && <span style={{ color: 'red' }}>Error: Server error</span>}
                </p>
              </div>
              <div className="pos-sign-in__actions">
                <button className="pos-sign-in__action" type="button" onClick={() => navigate('/')}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OfflineManagerDoWork;
